module.exports = __webpack_public_path__ + "static/media/user.286a4dbb.ico";